import { createStore } from 'vuex'

export default createStore({
  state: {
    address:'Victoria Station Approach, Hunts Bank,<br/>Manchester M3 1AR, United Kingdom',
    days:'Monday-Friday',
    hours:'8:45 AM - 4:30 PM',
    API:'https://mezz.vipfanportal.com/booking/api',
    repId:'',
    selectedBooking:'',
    selectedDate:'',
    availableBookings:[],
    selectedSchedule:'',
    client: {
      name:''
    }
  },
  getters: {
  },
  mutations: {
    setRepId(state, id) {
      state.repId = id;
    },
    setSelectedSchedule(state, date) {
      state.selectedSchedule = date;
    },
    setSelectedDate(state, date) {
      state.selectedDate = date;
    },
    setSelectedBooking(state, date) {
      state.selectedBooking = date;
    },
    setAvailableBookings(state, bookings) {
      state.availableBookings = bookings;
    },
  },
  actions: {
  },
  modules: {
  }
})
